module.exports = __webpack_public_path__ + "img/banner.be19fb54.jpg";